import { createFileRoute, redirect } from '@tanstack/react-router'
import { AssetDetail } from '@/features/accounting-assets/asset-detail'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/assets/$assetId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_asset.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AccountingAssetDetailRoute,
})

function AccountingAssetDetailRoute() {
  const { assetId } = Route.useParams()

  return <AssetDetail assetId={assetId} />
}
